import { IGroupData } from '@leafer-ui/interface'

import { UIData } from "./UIData"


export class GroupData extends UIData implements IGroupData {

}
